import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "@mui/material/Button";
import { Formik } from "formik";
import * as yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { ModalAllder } from "layouts/ModalAllder";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { customerHandler } from "../../../redux/handlers";

export function ChangeEmailModal({
  modal,
  setModal,
  setModalEmailSuccess,
  formaccount,
  customerID,
  refreshData,
}) {
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    email: "",
  });

  const schema = yup.object().shape({
    email: yup
      .string()
      .email("รูปแบบอีเมลไม่ถูกต้อง")
      .required("กรุณากรอกอีเมล"),
  });

  useEffect(() => {
    setForm({
      email: formaccount.email,
    });
  }, [formaccount]);

  const handleSubmit = async (values) => {
    try {
      await dispatch(
        customerHandler.updateCustomerEmail(customerID, values.email)
      );

      setModal((prev) => ({ ...prev, open: false }));

      await refreshData();
      setModalEmailSuccess((prev) => ({ ...prev, open: true }));
    } catch (error) {
      console.error("Error updating email:", error);
    }
  };

  return (
    <ModalAllder
      modal={modal}
      setModal={setModal}
      htitle={"เปลี่ยนอีเมล"}
      hbtn={true}
    >
      <div className="py-3">
        <div className="">
          <Formik
            enableReinitialize
            initialValues={form}
            validationSchema={schema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, handleChange, touched, errors, values }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <div className="text-center text-xl font-semibold text-[#4C4E64]/[0.87] mb-5">
                  กรุณาระบุอีเมลที่ต้องการเปลี่ยน
                </div>
                <Form.Group className="mb-3 form-st-3 pb-1">
                  <Form.Label className="mb-1">
                    อีเมล <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="อีเมล"
                    value={values.email}
                    onChange={handleChange}
                    isInvalid={touched.email && !!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="text-center pt-4 pb-3 btn-group-control">
                  <Button
                    size="large"
                    type="button"
                    className="btn-st-6 me-3 !border-[#6D788D] !rounded-lg !text-[#6D788D]"
                    style={{ width: "100px" }}
                    variant={"outlined"}
                    onClick={() =>
                      setModal((prev) => ({ ...prev, open: false }))
                    }
                  >
                    ยกเลิก
                  </Button>
                  <Button
                    size="large"
                    type="submit"
                    variant={"contained"}
                    className="btn-st-3 !rounded-lg"
                    style={{ width: "100px" }}
                  >
                    ยืนยัน
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </ModalAllder>
  );
}

export function ResetPasswordModal({
  modal,
  setModal,
  setModalResetPasswordSuccess,
  customerID,
  refreshData,
}) {
  const dispatch = useDispatch();
  const schema = yup.object().shape({});

  const handleResetPassword = async () => {
    try {
      const customerResponse = await dispatch(
        customerHandler.getCustomerById(customerID)
      );

      if (customerResponse && customerResponse.email) {
        setModal((prev) => ({ ...prev, open: false }));
        const result = await dispatch(
          customerHandler.requestResetPassword(customerResponse.email)
        );

        if (result) {
          setModalResetPasswordSuccess((prev) => ({
            ...prev,
            open: true,
          }));

          if (refreshData) {
            await refreshData();
          }
        } else {
          console.error("Failed to reset password");
        }
      } else {
        console.error("Customer email not found");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };

  return (
    <>
      <ModalAllder
        modal={modal}
        setModal={setModal}
        htitle={"รีเซ็ตรหัสผ่าน"}
        hbtn={true}
      >
        <div className="py-4">
          <div className="">
            <Formik
              enableReinitialize
              initialValues={{}}
              validationSchema={schema}
              onSubmit={async (values) => {
                await handleResetPassword();
              }}
            >
              {({
                handleSubmit,
                handleChange,
                touched,
                errors,
                values,
                setFieldValue,
                isInvalid,
                isValid,
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <div className="text-center text-2xl font-semibold text-[#4C4E64]/[0.87] mb-4">
                    คุณต้องรีเซ็ตรหัสผ่านใช่หรือไม่
                  </div>

                  <div className="text-center pt-4 pb-3  btn-group-control">
                    <Button
                      size="large"
                      type="button"
                      className="btn-st-6 me-3 !border-[#6D788D] !rounded-lg !text-[#6D788D]"
                      style={{ width: "100px" }}
                      variant={"outlined"}
                      onClick={() =>
                        setModal((prev) => ({ ...prev, open: false }))
                      }
                    >
                      ไม่ใช่
                    </Button>
                    <Button
                      size="large"
                      type="submit"
                      variant={"contained"}
                      className="btn-st-3  !rounded-lg"
                      style={{ width: "100px" }}
                    >
                      ใช่
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </ModalAllder>
    </>
  );
}

export function ChangeEmailSuccessModal({ modal, setModal }) {
  return (
    <>
      <ModalAllder modal={modal} setModal={setModal} htitle={""} hbtn={false}>
        <div className="py-4">
          <div className="">
            <div className="text-center mb-4">
              <CheckCircleRoundedIcon className="!text-[100px] text-[#2DC76D]" />
            </div>
            <div className="text-center text-2xl lh-base font-semibold text-[#4C4E64]/[0.87] mb-4">
              เปลี่ยนบัญชีอีเมลสำเร็จ
              <br /> รอการยืนยันจากลูกค้า
            </div>
          </div>
        </div>
      </ModalAllder>
    </>
  );
}

export function ResetPasswordSuccessModal({ modal, setModal }) {
  return (
    <>
      <ModalAllder modal={modal} setModal={setModal} htitle={""} hbtn={false}>
        <div className="py-4">
          <div className="">
            <div className="text-center mb-4">
              <CheckCircleRoundedIcon className="!text-[100px] text-[#2DC76D]" />
            </div>
            <div className="text-center text-2xl lh-base font-semibold text-[#4C4E64]/[0.87] mb-4">
              ระบบได้ส่งอีเมลรีเซ็ตรหัสผ่าน <br /> ให้ลูกค้าเรียบร้อยแล้ว
            </div>
          </div>
        </div>
      </ModalAllder>
    </>
  );
}
